module.exports = __webpack_public_path__ + "static/media/entregachips.05c1728b.jpg";